import { RefreshCw } from 'lucide-react';
import { useCatalog } from '@/features/sync/CatalogProvider';

function formatDateTime(iso: string | undefined): string {
  if (!iso) return 'nunca';
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(iso));
}

/** Estado do catálogo local e verificação manual de atualizações (F7-T13, F7-T14). */
export function CatalogStatusCard(): React.ReactElement {
  const { metadata, syncing, checkForUpdates } = useCatalog();

  return (
    <section className="rounded-xl bg-slate-800 p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 className="font-medium">Catálogo</h2>

          {metadata ? (
            <dl className="mt-2 space-y-0.5 text-sm text-slate-400">
              <div className="flex gap-2">
                <dt>Versão:</dt>
                <dd className="text-slate-300">{metadata.catalogVersion}</dd>
              </div>
              <div className="flex gap-2">
                <dt>Publicado em:</dt>
                <dd className="text-slate-300">{formatDateTime(metadata.generatedAt)}</dd>
              </div>
              <div className="flex gap-2">
                <dt>Última verificação:</dt>
                <dd className="text-slate-300">{formatDateTime(metadata.lastCheckedAt)}</dd>
              </div>
            </dl>
          ) : (
            <p className="mt-2 text-sm text-slate-400">
              Nenhum catálogo carregado ainda. Conecte-se à internet e verifique.
            </p>
          )}
        </div>

        <button
          type="button"
          onClick={() => void checkForUpdates()}
          disabled={syncing}
          className="flex min-h-11 shrink-0 items-center gap-2 rounded-lg bg-slate-700 px-4 text-sm font-medium active:bg-slate-600 disabled:opacity-60"
        >
          <RefreshCw size={16} aria-hidden className={syncing ? 'animate-spin' : undefined} />
          {syncing ? 'Verificando' : 'Verificar'}
        </button>
      </div>
    </section>
  );
}
